<template>
  <v-icon
    :color="color"
    :class="customClass"
    :x-large="xLarge"
    :large="large"
    :medium="medium"
    :small="small"
    :size="size"
    :left="left"
    :right="right"
  >
    {{ icon }}
  </v-icon>
</template>

<script>
export default {
  name: 'CSIcon',
  props: {
    icon: {
      type: String,
      default: '',
      required: true,
    },
    color: {
      type: String,
      default: undefined,
      required: false,
    },
    customClass: {
      type: String,
    },
    large: {
      type: Boolean,
      default: false,
      required: false,
    },
    medium: {
      type: Boolean,
      default: false,
      required: false,
    },
    xLarge: {
      type: Boolean,
      default: false,
      required: false,
    },
    small: {
      type: Boolean,
      default: false,
      required: false,
    },
    size: {
      type: Number || String,
      default: undefined,
      required: false,
    },
    left: {
      type: Boolean,
      default: false,
      required: false,
    },
    right: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
}
</script>
